"use client";

import React from "react";
import { useRouter } from "next/navigation";
import { useAddToCartSliderStore } from "@/app/store/cart/add-to-cart-slider-store";
import { AddToCartSlider, AddToCartSliderContent } from "@/composites/cart";

export function AddToCartSliderRoot(): JSX.Element | null {
	const store = useAddToCartSliderStore();
	let router: ReturnType<typeof useRouter> | null = null;

	try {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		router = useRouter();
	} catch (e) {
		// Storybook / non-Next.js context fallback
	}

	const handleClose = (): void => {
		store.close();
	};

	const handleContinueShopping = (): void => {
		store.close();
	};

	const handleViewCartAndCheckout = (): void => {
		store.close();
		if (router) {
			router.push("/cart");
		} else {
			window.location.href = "/cart";
		}
	};

	if (!store.isOpen || !store.addedProduct) {
		return null;
	}

	return (
		<AddToCartSlider
			isOpen={store.isOpen}
			onClose={handleClose}
			onContinueShopping={handleContinueShopping}
			onViewCartAndCheckout={handleViewCartAndCheckout}
		>
			<AddToCartSliderContent addedProduct={store.addedProduct} />
		</AddToCartSlider>
	);
}
